(function() { window.GUID_de05f8cb_ae49_4f82_8f9a_dac31d49be44 = { getGuid: function() { return "de05f8cb-ae49-4f82-8f9a-dac31d49be44"; } }; })();


//# sourceMappingURL=IValue.pre.js.map
